// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../utilities/encryptedBaseQuery";

export const learnApi = createApi({
  reducerPath: "learnApi",
  baseQuery: encryptedBaseQueryWithReauth(),
  // baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
  tagTypes: ["getLearnList", "getLearnPackage"],
  endpoints: (builder) => ({
    getLearnList: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getLearnList"],
    }),
    getLearnPackage: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getLearnPackage"],
    }),
    getLearnPackageDetail: builder.query({
      query: (endpoint) => `${endpoint}`,

    }),

    createPackage: builder.mutation({
      query: ({ endpoint, newPackage }) => {
        return {
          url: endpoint,
          method: "POST",
          body: newPackage,

        };
      },
      invalidatesTags: [],
    }),

    updatePackage: builder.mutation({
      query: ({ endpoint, updatedData }) => {
        return {
          url: endpoint,
          method: "PATCH",
          body: updatedData,

        };
      },
      invalidatesTags: [],
    }),

    updateLearnTopic: builder.mutation({
      query: ({ endpoint, updatedData }) => {
        return {
          url: endpoint,
          method: "PATCH",
          body: updatedData,

        };
      },
      invalidatesTags: [],
    }),

    createLearnTopic: builder.mutation({
      query: ({ endpoint, newLearn }) => {
        return {
          url: endpoint,
          method: "POST",
          body: newLearn,

        };
      },
      invalidatesTags: [],
    }),
    getLearnAnalytics: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),
  }),
});

export const {
  useGetLearnListQuery,
  useGetLearnAnalyticsQuery,
  useCreatePackageMutation,
  useGetLearnPackageQuery,
  useCreateLearnTopicMutation,
  useUpdatePackageMutation,
  useGetLearnPackageDetailQuery,
  useUpdateLearnTopicMutation,
} = learnApi;
